/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * showcan API
 * OpenAPI spec version: 1.0.0
 */
import type {
  Clinic,
  GetPublicClinicByUrlPathParams,
  ListClinicsResponse,
  ListPublicClinicsParams,
  SearchPublicClinicsParams,
} from "../../model";

import { customClient } from "../../custom-client";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Get a list of active clinic departments for a voice agent without authentication
 * @summary List clinics (public)
 */
export const getListPublicClinicsUrl = (
  agentId: string,
  params?: ListPublicClinicsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/public/voice-agents/${agentId}/clinics?${stringifiedParams}`
    : `/api/v1/public/voice-agents/${agentId}/clinics`;
};

export const listPublicClinics = async (
  agentId: string,
  params?: ListPublicClinicsParams,
  options?: RequestInit,
): Promise<ListClinicsResponse> => {
  return customClient<ListClinicsResponse>(
    getListPublicClinicsUrl(agentId, params),
    {
      ...options,
      method: "GET",
    },
  );
};

/**
 * Get an active clinic matching the given URL path
 * @summary Get clinic by URL path (public)
 */
export const getGetPublicClinicByUrlPathUrl = (
  agentId: string,
  params: GetPublicClinicByUrlPathParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/public/voice-agents/${agentId}/clinics/by-url?${stringifiedParams}`
    : `/api/v1/public/voice-agents/${agentId}/clinics/by-url`;
};

export const getPublicClinicByUrlPath = async (
  agentId: string,
  params: GetPublicClinicByUrlPathParams,
  options?: RequestInit,
): Promise<Clinic> => {
  return customClient<Clinic>(getGetPublicClinicByUrlPathUrl(agentId, params), {
    ...options,
    method: "GET",
  });
};

/**
 * Search active clinics by keyword for a voice agent without authentication
 * @summary Search clinics (public)
 */
export const getSearchPublicClinicsUrl = (
  agentId: string,
  params?: SearchPublicClinicsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/public/voice-agents/${agentId}/clinics/search?${stringifiedParams}`
    : `/api/v1/public/voice-agents/${agentId}/clinics/search`;
};

export const searchPublicClinics = async (
  agentId: string,
  params?: SearchPublicClinicsParams,
  options?: RequestInit,
): Promise<ListClinicsResponse> => {
  return customClient<ListClinicsResponse>(
    getSearchPublicClinicsUrl(agentId, params),
    {
      ...options,
      method: "GET",
    },
  );
};
